<template>
  <div>
    <b-row>
      <b-col cols="12" md="12">
        <b-alert
          show
          :variant="alertVariant"
          class="font-weight-bold clearfix d-block"
        >
          <slot name="header" />
          <b-overlay
            class="w-100"
            :show="(step === 'VERIFY_CODE' || accept) && parentShowLoadingText"
            :opacity="0.5"
          >
            <template #overlay>
              <div class="text-center">
                <p v-text="'در حال حاضر ویرایش این بخش غیرفعال می‌باشد.'" />
              </div>
            </template>

            <slot name="body" />
          </b-overlay>
          <b-row
            align-h="between"
            v-if="
              step === 'SEND_CODE' && !registered && validSendCode && forceShow
            "
          >
            <b-col cols="12" md="">
              <strong
                class="d-flex align-items-center justify-content-start w-100 new_register"
                :class="{
                  'text-muted': !accept,
                  'text-success': accept,
                }"
              >
                <b-form-checkbox
                  class="mx-0 mt-2"
                  id="accept"
                  v-model="accept"
                />
                <label for="accept" v-html="licenceText" />
              </strong>
            </b-col>
            <b-col cols="12" md="auto">
              <b-overlay
                :show="loading || parentLoading"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block float-right"
              >
                <b-button
                  variant="primary"
                  :disabled="!accept || parentLoading"
                  @click="accept && sendCode()"
                >
                  {{ sendCodeButtonTitle }}
                </b-button>
              </b-overlay>
            </b-col>
          </b-row>
          <b-overlay
            :show="loading || parentLoading"
            v-if="step === 'VERIFY_CODE' && !registered"
          >
            <b-form @submit.prevent="confirmModal = true">
              <b-row class="bg-white mx-0 mt-5 py-3 rounded">
                <b-col cols="12" md="12" class="mb-3">
                  <b-alert show variant="success" dismissible>
                    <i class="fa fa-check-circle fa-lg" />
                    <span>
                      کد تایید به شماره
                      <b class="text-primary" v-text="mobile" /> ارسال شد، لطفا
                      آن را وارد نمائید
                    </span>
                  </b-alert>
                </b-col>
                <b-col cols="12" md="3" class="mb-md-0 mb-3">
                  <b-form-group class="mb-0">
                    <b-form-input
                      v-model="$v.verifyCode.$model"
                      type="text"
                      minLength="4"
                      maxLength="4"
                      autocomplete="off"
                      :placeholder="$lang.verifyCode"
                      :state="
                        $v.verifyCode.$dirty ? !$v.verifyCode.$error : null
                      "
                    />
                    <b-form-invalid-feedback
                      :state="
                        $v.verifyCode.$dirty ? !$v.verifyCode.$error : null
                      "
                    >
                      <div v-if="!$v.verifyCode.required">
                        {{ $lang.error_required | replace($lang.verifyCode) }}
                      </div>
                      <div v-if="!$v.verifyCode.maxLength">
                        {{ $lang.error_max | replace($lang.verifyCode, 4) }}
                      </div>
                      <div v-if="!$v.verifyCode.minLength">
                        {{ $lang.error_max | replace($lang.verifyCode, 4) }}
                      </div>
                      <div v-if="!$v.verifyCode.numeric">
                        {{ $lang.error_numeric | replace($lang.verifyCode) }}
                      </div>
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="auto" md="auto" class="px-md-1">
                  <b-overlay
                    :show="loading || parentLoading"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block float-right"
                  >
                    <b-button
                      type="submit"
                      :variant="verifyCodeButtonVariant"
                      :disabled="
                        loading ||
                        parentLoading ||
                        !verifyCode ||
                        $v.verifyCode.$error
                      "
                      @click="confirmModal = true"
                    >
                      {{ verifyCodeButtonTitle }}
                    </b-button>
                  </b-overlay>
                </b-col>
                <b-col cols="auto" md="auto" class="px-md-1">
                  <b-button
                    type="reset"
                    variant="outline-danger"
                    @click="reset()"
                  >
                    {{ "انصراف و ویرایش" }}
                  </b-button>
                </b-col>
                <b-col cols="12" md="12" class="mt-3 text-muted fs_12">
                  <span v-text="'مدت زمان اعتبار کد ارسال شده: '" />
                  <span v-text="counter" class="text-primary ml-3" />
                </b-col>
              </b-row>
            </b-form>
          </b-overlay>
        </b-alert>
      </b-col>
    </b-row>
    <confirm
      title="تایید نهایی"
      :loadingSpinnerText="confirmLoadingSpinnerText"
      :description="confirmDescription"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      :loading="loading || parentLoading"
      :preventDefault="true"
      @ok="submit"
      @cancel="confirmModal = false"
    />
  </div>
</template>

<script>
import { pathOr } from "ramda";
import { generateExpireTime } from "@/shared/utils";
import confirm from "@/components/base/confirm";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { generateMobileOtpForMe } from "@/services";

export default {
  validations: {
    verifyCode: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
  },
  components: {
    confirm,
  },
  props: {
    alertVariant: {
      type: String,
      default: "info",
    },
    licenceText: {
      type: String,
      default: "صحت و صدق اطلاعات وارد شده مورد تایید اینجانب می‌باشد",
    },
    sendCodeButtonTitle: {
      type: String,
      default: "ارسال کد تایید",
    },
    verifyCodeButtonTitle: {
      type: String,
      default: "تایید و ثبت",
    },
    verifyCodeButtonVariant: {
      type: String,
      default: "primary",
    },
    parentLoading: {
      type: Boolean,
      default: false,
    },
    registered: {
      type: Boolean,
      default: true,
    },
    validSendCode: {
      type: Boolean,
      default: true,
    },
    forceShow: {
      type: Boolean,
      default: true,
    },
    submitted: {
      type: Boolean,
      default: false,
    },
    parentShowLoadingText: {
      type: Boolean,
      default: true,
    },
    parentMobile: {
      type: [String, Number],
      default: null,
    },
    confirmLoadingSpinnerText: {
      type: String,
      default: "",
    },
    confirmContentText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      accept: false,
      step: "SEND_CODE",
      mobile: "",
      verifyCode: null,
      timerQueue: null,
      counter: "1:00",
      controlCode: null,
      confirmModal: false,
    };
  },
  watch: {
    submitted(value) {
      value && this.reset();
    },
    accept(value) {
      this.$emit("updateAccept", value);
    },
  },
  computed: {
    confirmDescription() {
      return `${this.confirmContentText}<strong>${this.$lang.are_you_sure}</strong>`;
    },
  },
  destroyed() {
    clearInterval(this.timerQueue);
  },
  methods: {
    pathOr,
    generateExpireTime,
    reset() {
      this.loading = false;
      this.accept = false;
      this.confirmModal = false;
      this.verifyCode = null;
      this.$v.$reset();
      this.counter = "1:00";
      this.step = "SEND_CODE";
      clearInterval(this.timerQueue);
    },
    async sendCode() {
      try {
        this.loading = true;
        const mode = this.$route.name;
        const response = await generateMobileOtpForMe(mode, this.parentMobile);
        this.mobile = pathOr(null, ["mobile"], response);
        this.controlCode = pathOr(null, ["controlCode"], response);
        const expireTime = generateExpireTime(
          pathOr("", ["expireAt"], response)
        );
        this.timer(expireTime);
        this.step = "VERIFY_CODE";
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading || !this.verifyCode) {
        return;
      }
      const params = {
        control_code: this.controlCode,
        two_step_code: this.verifyCode,
      };
      this.$emit("setData", params);
    },
    timer(seconds = 0) {
      let distance = seconds * 1000;
      clearInterval(this.timerQueue);
      this.timerQueue = setInterval(() => {
        distance = distance - 1000;
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        minutes = minutes > 0 ? minutes : 0;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        seconds = seconds >= 10 ? seconds : `0${seconds}`;
        this.counter = minutes + ":" + seconds;
        if (distance < 0) {
          this.reset();
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scope>
.new_register .custom-checkbox {
  margin-bottom: 15px;
}

.new_register
  .custom-control-input:focus
  ~ .new_register
  .custom-control-label::before,
.new_register
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  box-shadow: none;
  border-color: #c7cdd3;
}
.new_register .custom-checkbox .custom-control-label::before {
  border-radius: 4px;
}

.new_register .custom-control-label::before {
  background-image: none;
  border: 2px solid #c7cdd3;
  background-color: transparent;
}
.new_register
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 4px;
  box-shadow: none;
}
.new_register
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 25px;
  box-shadow: none;
}

.new_register .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
  border: 2px solid #c7cdd3;
  border-radius: 25px;
  background-color: transparent;
}
.new_register .custom-control-input:checked ~ .custom-control-label::before {
  background-color: transparent;
  background: transparent;
  color: transparent;
  border-top: 0;
  border-right: 0;
  border-bottom: 3px solid #00bcd4;
  border-left: 3px solid #00bcd4;
  content: "";
  width: 17px;
  height: 8px;
  border-radius: 0;
  transform: rotate(-45deg);
  position: absolute;
  top: 2px;
  right: -27px;
  z-index: 1;
  box-shadow: none;
}
</style>
